// extracted by mini-css-extract-plugin
export default {"l_BlurEmptyBlock_main":"BlurEmptyBlock_l_BlurEmptyBlock_main__aNx-Z","top":"BlurEmptyBlock_top__N3CGE","bottom":"BlurEmptyBlock_bottom__m8bNf"};